import { getAppGlobals } from "@/plugins/appGlobals";

export default function useTeamService() {
  const app = getAppGlobals();

  function authHeader() {
    return {
      Authorization: `bearer ${
        app.$Session.get(app.$userSessionName).token.Value
      }`
    };
  }

  function list() {
    return app.$axios.get("api/Team", { headers: authHeader() });
  }

  // GET /api/Team/{id} — uma unidade/equipe.
  function getById(id) {
    return app.$axios.get(`api/Team/${id}`, { headers: authHeader() });
  }

  // GET /api/Team/transfer-targets — destinos escopados por role (árvore).
  function transferTargets() {
    return app.$axios.get("api/team/transfer-targets", {
      headers: authHeader()
    });
  }

  // GET /api/Team/{id}/has-patients — { hasPatients, patientCount }.
  // Usado para saber se a equipe tem pacientes sem carregar a lista completa.
  function hasPatients(id) {
    return app.$axios.get(`api/Team/${id}/has-patients`, {
      headers: authHeader()
    });
  }

  // GET /api/Team/{id}/has-professionals — { hasProfessionals, professionalCount }.
  function hasProfessionals(id) {
    return app.$axios.get(`api/Team/${id}/has-professionals`, {
      headers: authHeader()
    });
  }

  // POST /api/Team — cria uma equipe/unidade. payload: { name, parent }.
  // Resposta: { id, name, status, isTeam }.
  function create(payload) {
    return app.$axios.post("api/Team", payload, { headers: authHeader() });
  }

  // PUT /api/Team/{id} — atualiza o nome. payload: { name }.
  function update(id, payload) {
    return app.$axios.put(`api/Team/${id}`, payload, { headers: authHeader() });
  }

  // DELETE /api/Team/{id} — exclui a unidade/equipe.
  function remove(id) {
    return app.$axios.delete(`api/Team/${id}`, { headers: authHeader() });
  }

  // GET /api/Team/{id}/professionals — membros e disponíveis da equipe.
  function getProfessionals(id) {
    return app.$axios.get(`api/team/${id}/professionals`, {
      headers: authHeader()
    });
  }

  // PUT /api/Team/{id}/professionals — grava vínculo/navegador dos membros.
  function updateProfessionals(id, payload) {
    return app.$axios.put(`api/team/${id}/professionals`, payload, {
      headers: authHeader()
    });
  }

  return {
    list,
    getById,
    transferTargets,
    hasPatients,
    hasProfessionals,
    create,
    update,
    remove,
    getProfessionals,
    updateProfessionals
  };
}
